import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=d45b8da0&"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45b8da0')) {
      api.createRecord('d45b8da0', component.options)
    } else {
      api.reload('d45b8da0', component.options)
    }
    module.hot.accept("./ErrorDialog.vue?vue&type=template&id=d45b8da0&", function () {
      api.rerender('d45b8da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/ErrorDialog.vue"
export default component.exports